import { startsWith, endsWith } from 'lodash'
// export const Scalar = {
//     value,
//     constructor(value = '', ...rest) {
//         this.value = value
//     }
// }

function mk(x)
{
    return function(value, ...args) {
        return x.init(value, ...args)
    }
}

export const Endpoint = {
    value: '',    
    init(uri, tag) {
        if (startsWith(uri, '/') || endsWith(uri, '/')) {
            throw new Error(`${tag}不能以'/'开始和结束`)
        }
        this.value = uri
        return this
    }
}
export const mkEndpoint = mk(Endpoint)

export const Url = {
    value: '',
    init(x, tag) {
        if (! /^(ftp|http|https):\/\/[^ "]+$/.test(x)) {
            throw new Error(`${x}不是合法的url`)
        }
        this.value = x
        return this
    }
}
export const mkUrl = mk(Url)



// WEBPACK FOOTER //
// ./plugins/req/Scalar.js